import { useTranslation } from "react-i18next";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, TextField, Typography } from "@mui/material";
import { CloseRounded } from "@mui/icons-material";
import AffiliateAccordionDetail from "./AffiliateAccordionDetail";
import { useAffiliateActions } from "../../../service/useAffiliateActions";
import { useContext, useEffect, useState } from "react";
import { GlobalContext } from "../../../../../util/state/GlobalContextProvider";
import { useStatusValuesAffiliate } from "../../../component/useStatusValuesAffiliate";

interface AffiliateDetailModalProps {
    open: boolean,
    setOpen: Function,
    affiliateId: string
}

const AffiliateDetailModal = ({ open, setOpen, affiliateId }: AffiliateDetailModalProps) => {
    const { t } = useTranslation(['salesmarketing', 'translation']);
    const affiliateActions = useAffiliateActions();
    const { getStatusLabelAffiliate } = useStatusValuesAffiliate();
    const { globalData } = useContext(GlobalContext);
    const [detail, setDetail] = useState({
        tenantId: "",
        dealerId: "",
        genVendorCode: "",
        networkBusinessTravelCode: "",
        typology: "",
        status: "",
        naming: "",
        bpCode: "",
        bpKind: "",
        iataCode: "",
        serviceType: [],
        country: "",
        region: "",
        city: "",
        address: "",
        streetNumber: "",
        postalCode: "",
        province: "",
        phoneNumber: "",
        cellPhoneNumber: "",
        email: "",
        area: "",
        website: "",
        incomeCode: "",
        percipient: "",
        percipientAddress: "",
        percipientCity: "",
        percipientProvince: "",
        percipientPostalCode: "",
        repCompanyName: "",
        repVatNumber: "",
        siren: "",
        siret: "",
        representativeName: "",
        representativeEmail: "",
        representativeCellphone: "",
        taxCode: "",
        sdiCode: "",
        representativeContactName: "",
        representativeContactEmail: "",
        representativeContactCellphone: "",
        representativeIban: "",
        representativeAddress: "",
        representativeStreetNumber: "",
        representativePostalCode: "",
        representativeCity: "",
        representativeProvince: "",
        representativeHqCellphone: "",
        representativePec: ""
    });

    const fetchDetail = async (affiliateId: any) => {
        setDetail(await affiliateActions.detailAffiliate(affiliateId));
    }

    useEffect(() => {
        if (open) {
            fetchDetail(affiliateId);
        }
    }, [open])

    return (
        <>
            <Dialog open={open} maxWidth={false}>
                <DialogTitle>
                    <Grid container item xs={12}>
                        <Grid item xs={10}>
                            <Typography color="primary" className="ModalTitle">
                                {t('salesmarketing:affiliate.detailModal.title')}
                            </Typography>
                        </Grid>
                        <Grid item xs={1}>
                            <IconButton sx={{ position: 'absolute', right: 16, top: 12, }} onClick={() => { setOpen(false) }}>
                                <CloseRounded/>
                            </IconButton>
                        </Grid>
                    </Grid>
                </DialogTitle>
                <DialogContent className="AffiliateDetailModalBody">
                    <Grid container spacing={2}>
                        {globalData?.user?.legalEntities?.length > 1 || globalData?.user?.dealers?.length > 1 ?
                            <Grid container item xs={12} spacing={1}>
                                {globalData?.user?.legalEntities?.length > 1 ?
                                    <Grid item xs={3}>
                                        <TextField
                                            fullWidth
                                            label={t('salesmarketing:legalEntityField')}
                                            value={detail?.tenantId}
                                            InputProps={{readOnly:true}}
                                        />
                                    </Grid> : null
                                }
                                {globalData?.user?.dealers?.length > 1 ?
                                    <Grid item xs={3}>
                                        <TextField
                                            fullWidth
                                            label={t('salesmarketing:dealerField')}
                                            value={detail?.dealerId}
                                            InputProps={{readOnly:true}}
                                        />
                                    </Grid> : null
                                }
                            </Grid> : null
                        }
                        <Grid container item xs={12} spacing={1}>
                            <Grid item xs={3}>
                                <TextField
                                    fullWidth
                                    label={t('salesmarketing:affiliate.detailContent.companyNameField')}
                                    value={detail?.repCompanyName}
                                    InputProps={{readOnly:true}}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <TextField
                                    fullWidth
                                    label={t('salesmarketing:affiliate.detailContent.vatNumberField')}
                                    value={detail?.repVatNumber}
                                    InputProps={{readOnly:true}}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <TextField
                                    fullWidth
                                    label={t('salesmarketing:affiliate.detailContent.sirenField')}
                                    value={detail?.siren}
                                    InputProps={{readOnly:true}}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <TextField
                                    fullWidth
                                    label={t('salesmarketing:affiliate.detailContent.siretField')}
                                    value={detail?.siret}
                                    InputProps={{readOnly:true}}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <TextField
                                    fullWidth
                                    label={t('salesmarketing:affiliate.detailContent.vendorCodeField')}
                                    value={detail?.genVendorCode}
                                    InputProps={{readOnly:true}}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <TextField
                                    fullWidth
                                    label={t('salesmarketing:affiliate.detailContent.bpCodeField')}
                                    value={detail?.bpCode}
                                    InputProps={{readOnly:true}}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <TextField
                                    fullWidth
                                    label={t('salesmarketing:affiliate.detailContent.statusField')}
                                    value={getStatusLabelAffiliate(detail?.status)}
                                    InputProps={{readOnly:true}}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <TextField
                                    fullWidth
                                    label={t('salesmarketing:affiliate.detailContent.networkBusinessTravelCodeField')}
                                    value={detail?.networkBusinessTravelCode}
                                    InputProps={{readOnly:true}}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <TextField
                                    fullWidth
                                    label={t('salesmarketing:affiliate.detailContent.typologyField')}
                                    value={detail?.typology}
                                    InputProps={{readOnly:true}}
                                />
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <AffiliateAccordionDetail detail={detail} isDisabled={false} />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions className="ModalFooter">
                    <Grid container rowSpacing={3} columnSpacing={3} sx={{paddingTop: "50px"}}>
                        <Grid container item xs={12} rowSpacing={1} columnSpacing={3}
                              justifyContent={"flex-end"}>
                            <Grid item>
                                <Button fullWidth size="small" color={"accent"} onClick={() => {
                                    setOpen(false)
                                }}>
                                    {t('salesmarketing:affiliate.buttons.close')}
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
        </>
    );
}

export default AffiliateDetailModal;